import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import Loader from '../../animation/Loader.json';
import { fetchApi } from "../../utlis/axios";
import { FaSearch } from "react-icons/fa";
import Pagination from "../../ListingPage/Pagination";

export const KwfDonation = () => {
  const [familyData, setFamilyData] = useState([]);
  const { access } = useSelector(state => state.authSlice.userInfo);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(null);

  const navigate = useNavigate();

  const getFamilyData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`kwf-donation/?search=${searchQuery}`, {
        headers: {
          'Authorization': `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setFamilyData(result?.data);
        console.log('result data.......', result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    getFamilyData();
  }, [searchQuery, access]);

  const handleTableRowClick = (id) => {
    console.log("id", id);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(familyData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;
    
    try {
      const result = await fetchApi.get(
        `kwf-donation/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
      return result;
    } catch (error) {
      throw error;
    }
  };
  
  const handlePageClick = (pageNumber) => {
    console.log("pageNumbber", pageNumber);
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setFamilyData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  
  
  return (
    <div className="w-full px-[16px] md:px-10 min-h-screen mt-16 max-w-screen-xl mx-auto">
      {/* Top Section */}
      <h1 className="md:text-4xl text-2xl font-bold capitalize mb-4">
        KWF Donations
      </h1>
      <div className="flex items-center justify-between gap-3 mt-6 md:mb-4 mb-[12px]">
        {/* Search */}
        <div className="relative flex justify-center border rounded-full sm:py-2 py-[4px] px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
          <FaSearch className="text-gray-500" />
          <input
            type="search"
            name="search"
            className="w-full outline-none text-gray-600 py-1 px-1"
            placeholder="Search here...."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="bg-primary-green text-white text-left">
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Name
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap ">
                Amount
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Date
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Reason
              </th>
            </tr>
          </thead>

          <tbody className="">
            {isLoading ? (
              <tr>
                <td colSpan={4} className="h-[60vh]">
                  <div className="flex justify-center items-center h-full w-full">
                    <Lottie
                      loop={true}
                      animationData={Loader}
                      style={{ width: "200px" }}
                      className="auth-sidebar-video"
                    />
                  </div>
                </td>
              </tr>
            ) : familyData?.results?.length > 0 ? (
              familyData?.results?.map((data, index) => (
                <tr
                  key={index}
                  className={`cursor-pointer ${
                    index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                  } hover:bg-gray-200`}
                  onClick={() => handleTableRowClick(data?.id)}
                >
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap">
                    <div className="flex flex-col">
                      <span className="font-semibold text-gray-800">liam</span>
                      <span className="text-sm text-gray-500">{data?.email}</span>
                    </div>
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    <span className="font-medium text-gray-700">
                      {data?.amount}
                    </span>
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate ">
                    <span className="text-gray-600">
                      {moment.utc(data?.updated_at?.toString()).format('MM/DD/YYYY')}
                    </span>
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    {data?.reason}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="p-4 text-center">
                  No donations found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

       {/* Pagination */}
       <div className="flex justify-center items-center mt-6">
        <Pagination
          currentPage={currentPage}
          handlePageClick={handlePageClick}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};